import { withNamespaces } from 'react-i18next';
import Spinner from 'react-bootstrap/Spinner';

import { VAT_CHECK_STATUS } from 'src/modules/3rd-party-management/hooks/useVatNumberCheck';

const VatNumberCheckFeedback = ({
    t,
    status,
    details
}) => {
    if(status === VAT_CHECK_STATUS.IDLE) return null;

    if(status === VAT_CHECK_STATUS.CHECKING){
        return (
            <span className="d-inline-flex align-items-center mt-1 text-muted font-size-12">
                <Spinner className="me-1" animation="border" size="sm" />
                {t('Checking the VAT ID')}...
            </span>
        );
    }

    if(status === VAT_CHECK_STATUS.VALID){
        return (
            <span className="d-block mt-1 text-success font-size-12">
                {
                    details?.name ? (
                        `${t('VAT ID verified')} - ${details.name}`
                    ) : (
                        t('VAT ID verified')
                    )
                }
            </span>
        );
    }

    if(status === VAT_CHECK_STATUS.INVALID){
        return (
            <span className="d-block mt-1 text-warning font-size-12">
                {t('This VAT ID could not be verified in the EU VAT register. You can still save it.')}
            </span>
        );
    }

    return (
        <span className="d-block mt-1 text-muted font-size-12">
            {t('The VAT validation service is temporarily unavailable, so this VAT ID could not be checked.')}
        </span>
    );
};

export default withNamespaces()(VatNumberCheckFeedback);
